import type { FieldDecision, FieldSnapshot } from '@mio/shared';

/** Only published direct messages from this record's owner can explain its request. */
export function decisionOwnerConversation(snapshot: FieldSnapshot, decision: FieldDecision) {
  const direct = snapshot.messages.filter(
    (message) => message.actorId === decision.owner && !message.meetingId,
  );
  const request = decision.confirmationOperationId
    ? direct.findLast(
        (message) =>
          message.role === 'learner' &&
          message.operationId === decision.confirmationOperationId &&
          message.sourceIds.includes(decision.id),
      )
    : undefined;
  const operation = request?.operationId
    ? snapshot.operations.find((item) => item.id === request.operationId && item.kind === 'turn')
    : undefined;
  const reply = operation
    ? direct.findLast(
        (message) => message.role === 'colleague' && message.operationId === operation.id,
      )
    : undefined;
  return { request, operation, reply, linked: !!decision.confirmationOperationId };
}

/** Summarize repeated legacy requests without deleting or changing saved history. */
export function decisionHistoryGroups(history: FieldDecision['history']) {
  const groups: { entry: FieldDecision['history'][number]; count: number }[] = [];
  for (const entry of history) {
    const previous = groups.at(-1);
    const { at: _at, ...content } = entry;
    const { at: _previousAt, ...previousContent } = previous?.entry ?? {};
    if (
      previous &&
      entry.status === 'proposed' &&
      entry.by === 'learner' &&
      JSON.stringify(content) === JSON.stringify(previousContent)
    ) {
      previous.entry = entry;
      previous.count += 1;
    } else groups.push({ entry, count: 1 });
  }
  return groups;
}
